import React from 'react'

function DashboardMembers() {
  return <>
  <div>Bu sayfa PRivate members sayfası</div>
  </>
  
}

export default DashboardMembers